import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTrackDocumentQuery } from "../../hooks/track-document.hook";
import { TrackDocumentType } from "../../types";
import { useParams } from "react-router-dom";
import MediaGallery from "./media-gallery";
import UploadDocument from "./documents-list/upload-document";
import { useDownloadDocumentCategory } from "../../hooks/download-document-category.hook";
import { ArrowDownToLine } from "lucide-react";
import useDownloadDocument from "../../hooks/download-document.hook";
import useDeleteDocument from "../../hooks/delete-document.hooks";

export default function MediaDocuments() {
  const theme = useTheme();

  const { trackId } = useParams<{ trackId: string }>();

  const documentType: TrackDocumentType = "Media";

  const { data, isLoading } = useTrackDocumentQuery({
    uid: trackId,
    documentType: "Media",
  });

  const { isFetching, refetch } = useDownloadDocumentCategory(documentType);
  const { download, isDownloading } = useDownloadDocument();
  const { deleteDocument } = useDeleteDocument();

  const handleDownload = (_url: string, index: number) => {
    if (data?.[index]) {
      download(data[index].uid);
    }
  };

  const handleDelete = (_url: string, index: number) => {
    if (data?.[index]) {
      deleteDocument(data[index].uid);
    }
  };

  return (
    <Stack
      p={theme.nawy.spacing.md}
      borderRadius={theme.nawy.radius.xl}
      bgcolor={theme.nawy.colors.primitives.white[100]}
      gap={theme.nawy.spacing.sm}
      width="100%"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={theme.nawy.spacing.sm}
      >
        <Typography
          sx={{ ...theme.nawy.typography.english.variants.body.md.semibold }}
        >
          Media
        </Typography>

        {data && data?.length > 0 && (
          <UploadDocument documentType={documentType} />
        )}
      </Stack>

      <MediaGallery
        data={data?.map((d) => d.fileUrl) || []}
        isLoading={isLoading}
        onDownload={handleDownload}
        onDelete={handleDelete}
        isDownloading={isDownloading}
      />

      {data && data.length > 0 ? (
        <Button
          onClick={() => refetch()}
          disabled={isFetching}
          fullWidth
          startIcon={<ArrowDownToLine size={16} />}
          sx={{
            backgroundColor: theme.nawy.colors.semantic.layer.accentLight,
            color: theme.nawy.colors.semantic.text.accent,
            textTransform: "none",
          }}
        >
          Download all
        </Button>
      ) : (
        <UploadDocument documentType={documentType} showLabel />
      )}
    </Stack>
  );
}
